export namespace CoreSpaceActions {
  export class MySpaces {
    static readonly type = '[Space] Get My Spaces';
  }
}
